import React, { useState, useEffect } from "react";
import {
    NavWrapper,
    ListWrapper,
    NavItem,
    NavLink,
    StyledAnchor,
    PrimaryNavItem,
    StyledInternalNavbar,
    StyledPrimaryWrapper,
} from "./StyledComponents";
import IntNavRightArrow from "../../assets/SVGComponents/IntNavRightArrow";
import fetchDetailIcon from "../../assets/store/fetchDetailIcon";
import { Dropdown } from "./Dropdown";
import { findLinkByName } from "../../assets/store/findLink";
import { formatText } from "../../assets/store/formatText";

function InternalNavbar(props) {
    const [screenSize, setScreenSizes] = useState(
        window?.window?.deviceDetect?.getWindowData() || {
            viewWidth: document.documentElement.clientWidth,
            isMobile: false,
            isDesktop: false,
            isTablet: false,
        }
    );
    const [visible, setVisible] = useState(false);
    const [transformSvg, setTransformSvg] = useState(false);
    const toggleDropdownVisibility = () => {
        if (dropdownLinksList.length > 1) {
            setVisible((prev) => !prev);
            setTransformSvg((prev) => !prev);
        } else {
            setVisible(false);
        }
    };

    const {
        internal_navbar,
        defaultFontFamily,
        dataAttributes,
        links,
        rowData,
        oem,
    } = props;

    const { hide_cta_icons } = oem || {};

    const {
        button_1_text,
        button_1_url,
        button_1_url_id,
        selected_button_1_url,
        button_order,
        include_button_1,
        include_button_2,
        include_button_3,
        include_button_4,
        include_button_5,
        include_primary_button,
        open_button_1_in_new_tab,
        open_primary_button_in_new_tab,
        primary_button_class,
        primary_button_id,
        primary_button_text,
        primary_button_url,
        primary_button_url_id,
        selected_primary_button_url,
        internal_navbar_theme,
    } = internal_navbar;
    const {
        navbar_button_background_color,
        navbar_button_background_hover_color,
        navbar_button_text_color,
        navbar_button_text_hover_color,
        navbar_color,
        primary_button_background_color,
        primary_button_border_radius,
        primary_button_background_hover_color,
        primary_button_text_color,
        primary_button_text_hover_color,
        navbar_button_border_color,
        primary_button_border_color,
        font_size,
        font_style,
        font_weight,
        font_family,
        letter_spacing,
        text_transform,
    } = internal_navbar_theme;

    const newButtonOrder = JSON.parse(button_order);

    let navbarFontFamily = font_family
        ? font_family.font_family_name
        : defaultFontFamily;

    const internalNavbarDataAttr = {
        "data-internalnavbarid": internal_navbar.id,
        ...dataAttributes,
    };

    const genericNavbarProps = {
        justifyContent:
            screenSize?.isMobile || hide_cta_icons ? "center" : "space-between",
        alignItems: "center",
        textColor: navbar_button_text_color ?? "white",
        hoverTextColor: navbar_button_text_hover_color ?? "black",
        borderColor: navbar_button_border_color,
        buttonColor: navbar_button_background_color ?? navbar_color,
        hoverButtonColor: navbar_button_background_hover_color,
        letterSpacing: letter_spacing,
        textTransform: text_transform,
    };

    const navLinkProps = {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
    };

    const primaryNavButtonProps = {
        buttonColor: primary_button_background_color ?? "white",
        hoverButtonColor: primary_button_background_hover_color ?? "#e2e0e0",
        textColor: primary_button_text_color ?? "black",
        padding: screenSize?.isMobile ? "6px" : "0 32px",
        hoverTextColor: primary_button_text_hover_color,
        borderColor: primary_button_border_color,
        borderRadius: primary_button_border_radius,
        letterSpacing: letter_spacing,
        textTransform: text_transform,
    };
    const serviceLink = findLinkByName({
        links,
        linkType: "Service Specials (SMP)",
    });
    const partsLink = findLinkByName({
        links,
        linkType: "Parts Specials (PMP)",
    });
    const accessoryLink = findLinkByName({
        links,
        linkType: "Accessories Specials (AMP)",
    });
    const tiresLink = findLinkByName({
        links,
        linkType: "Tire Specials (TMP)",
    });
    const spanishLink = findLinkByName({
        links,
        linkType: "Spanish Service Specials (Spanish SMP)",
    });
    const rebateLink = findLinkByName({
        links,
        linkType: "Rebate Service Specials (Rebate SMP)",
    });
    const valvolineLink = findLinkByName({
        links,
        linkType: "Valvoline Service Specials (Valvoline SMP)",
    });
    const nationalOffersLink = findLinkByName({
        links,
        linkType: "National Offers",
    });
    const expressLink = findLinkByName({
        links,
        linkType: "Express Specials (ExpressMP)",
    });
    const bgLink = findLinkByName({
        links,
        linkType: "BG Specials (BGMP)",
    });

    const maintenanceMenuLink = findLinkByName({
        links,
        linkType: "Maintenance Menu",
    });

    const dropdownLinksList = [
        serviceLink,
        partsLink,
        accessoryLink,
        tiresLink,
        spanishLink,
        rebateLink,
        valvolineLink,
        nationalOffersLink,
        expressLink,
        bgLink,
        maintenanceMenuLink,
    ].filter((item) => item && item.link);

    const dropdownProps = {
        internalNavbarDataAttr,
        serviceLink,
        partsLink,
        accessoryLink,
        tiresLink,
        spanishLink,
        rebateLink,
        valvolineLink,
        nationalOffersLink,
        expressLink,
        bgLink,
        maintenanceMenuLink,
        navbarFontFamily,
        internal_navbar_theme,
        rowData,
        setVisible,
        setTransformSvg,
        isMobile: screenSize?.isMobile ?? null,
    };
    const selectedButtons = [];
    include_button_1 && selectedButtons.push("button_1");
    include_button_2 && selectedButtons.push("button_2");
    include_button_3 && selectedButtons.push("button_3");
    include_button_4 && selectedButtons.push("button_4");
    include_button_5 && selectedButtons.push("button_5");
    //check which link to use when Specials button opens a link instead of a dropdown
    let selectedSpecialsNavLink =
        selected_button_1_url &&
            selected_button_1_url.link &&
            selected_button_1_url.link !== ""
            ? selected_button_1_url.link
            : null;
    let customSpecialsNavLink =
        button_1_url && button_1_url !== "" ? button_1_url : null;
    const specialsNavLink =
        dropdownLinksList.length === 1
            ? dropdownLinksList[0].link
            : selectedSpecialsNavLink
                ? selectedSpecialsNavLink
                : customSpecialsNavLink
                    ? customSpecialsNavLink
                    : null;

    const changeHref = () => {
        window.location.href = specialsNavLink;
    };
    const arrowStyleProps = {
        fill: null,
        svgIconSize: 8,
        transform: transformSvg ? "rotate(90deg)" : null,
    };
    // used reduce to create each instance of button
    const internalNavTopButton = selectedButtons.reduce((obj, buttonText) => {
        const text = internal_navbar[buttonText + "_text"];
        const key = buttonText.slice(7);
        const id = internal_navbar[buttonText + "_id"];
        const selectedLinkObj =
            internal_navbar["selected_" + buttonText + "_url"];
        const selectedLinkTarget = selectedLinkObj?.open_link_in_new_tab;
        const url = selectedLinkObj
            ? null
            : internal_navbar[buttonText + "_url"];
        const open_tab = internal_navbar["open_" + buttonText + "_in_new_tab"];

        obj[buttonText] = {
            link: selectedLinkObj?.link ? selectedLinkObj.link : url ? url : "",
            content: (
                <NavItem
                    key={key}
                    {...genericNavbarProps}
                    data-testid={`internal-nav-${buttonText}`}
                    className="FODInternalNavbarListItem"
                >
                    <NavLink
                        {...navLinkProps}
                        tabIndex={
                            screenSize?.isMobile || screenSize?.isTablet
                                ? parseInt(key) + 1
                                : key
                        }
                        href={
                            selectedLinkObj?.link
                                ? selectedLinkObj.link
                                : url
                                    ? url
                                    : ""
                        }
                        {...internalNavbarDataAttr}
                        data-clicklocation={`Internal Navbar Button ${buttonText.slice(
                            7
                        )}`}
                        data-clickurl={
                            selectedLinkObj?.link
                                ? selectedLinkObj.link
                                : url
                                    ? url
                                    : "No link"
                        }
                        className={`${buttonText} FODGAInternalNavbarItem FODV5GAInternalNavbarClickEvent`}
                        id={id}
                        target={
                            selectedLinkObj
                                ? selectedLinkTarget
                                    ? "_blank"
                                    : "_self"
                                : open_tab
                                    ? "_blank"
                                    : "_self"
                        }
                    >
                        {hide_cta_icons
                            ? null
                            : fetchDetailIcon(
                                `${text}`,
                                null,
                                screenSize?.isMobile ? 20 : 24
                            )}
                        {formatText(rowData, text)}
                    </NavLink>
                </NavItem>
            ),
        };

        return obj;
    }, {});

    const primaryLinkObj = selected_primary_button_url;
    const primaryTarget = primaryLinkObj?.open_link_in_new_tab;
    const primaryLink = primaryLinkObj?.link
        ? primaryLinkObj.link
        : primary_button_url
            ? primary_button_url
            : "";
    const specialsLinkObj = selected_button_1_url;
    const specialsTarget = specialsLinkObj?.open_link_in_new_tab;
    const hideSpecialsButton =
        dropdownLinksList.length === 0 && !specialsNavLink;
    const button_1 =
        // Button 1 becomes a dropdown when text is Specials
        include_button_1 &&
            button_1_text === "Specials" &&
            !hideSpecialsButton ? (
            <NavItem
                key={1}
                {...genericNavbarProps}
                onMouseDown={
                    dropdownLinksList.length > 1
                        ? toggleDropdownVisibility
                        : changeHref
                }
                data-testid="specials-internal-nav-button_1"
                className="FODInternalNavbarListItem"
            >
                <StyledAnchor
                    dropdownLinksListLength={dropdownLinksList.length}
                    {...internalNavbarDataAttr}
                    data-clicklocation="Specials Navbar Button"
                    data-clickurl={specialsNavLink}
                    className={
                        dropdownLinksList.length > 1
                            ? "specials_button FODGAInternalNavbarItem FODV5GAInternalNavbarClickEvent"
                            : "specials_button FODGAInternalNavbarItem FODGAInternalNavbarItemLink FODV5GAInternalNavbarClickEvent"
                    }
                    target={
                        specialsTarget !== undefined
                            ? specialsTarget
                                ? "_blank"
                                : "_self"
                            : open_button_1_in_new_tab &&
                                dropdownLinksList.length > 1
                                ? "_blank"
                                : "_self"
                    }
                    {...navLinkProps}
                    tabIndex={
                        screenSize?.isMobile || screenSize?.isTablet ? "2" : "1"
                    }
                    onFocus={() => {
                        if (dropdownLinksList.length > 1) {
                            setVisible(true);
                            setTransformSvg(true);
                        }
                    }}
                >
                    {hide_cta_icons
                        ? null
                        : fetchDetailIcon(
                            button_1_text,
                            null,
                            screenSize?.isMobile ? 20 : 24
                        )}
                    <span
                        style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                        }}
                    >
                        {formatText(rowData, "Specials")}
                        {dropdownLinksList.length > 1 ? (
                            <IntNavRightArrow {...arrowStyleProps} />
                        ) : null}
                    </span>
                </StyledAnchor>
            </NavItem>
        ) : include_button_1 && internalNavTopButton["button_1"].link ? (
            internalNavTopButton["button_1"].content
        ) : null;
    const button_2 =
        include_button_2 && internalNavTopButton["button_2"].link
            ? internalNavTopButton["button_2"].content
            : null;
    const button_3 =
        include_button_3 && internalNavTopButton["button_3"].link
            ? internalNavTopButton["button_3"].content
            : null;
    const button_4 =
        include_button_4 && internalNavTopButton["button_4"].link
            ? internalNavTopButton["button_4"].content
            : null;
    const button_5 =
        include_button_5 && internalNavTopButton["button_5"].link
            ? internalNavTopButton["button_5"].content
            : null;
    const buttons = {
        1: button_1,
        2: button_2,
        3: button_3,
        4: button_4,
        5: button_5,
    };

    useEffect(() => {
        // set device detect to track component and provide screen dimension to internalNavbar local state.
        const key = window.window.deviceDetect.addStateAccessor({
            stateAccessor: setScreenSizes,
        });

        return () => {
            window.window.deviceDetect.removeStateAccessor({ key: key });
        };
    }, []);

    return (
        <StyledInternalNavbar
            className="FODInternalNavbarWrapper"
            id="FODInternalNavbarWrapper"
            style={{
                fontFamily: navbarFontFamily,
                fontWeight: font_weight,
                fontStyle: font_style,
                // gave this a default value because font_size has an empty string when input is not filled
                fontSize: font_size ? font_size : "1rem",
                backgroundColor:
                    navbar_color ?? primary_button_background_color,
            }}
            includePrimaryBtn={include_primary_button && primaryLink !== ""}
        >
            {include_primary_button && primaryLink ? (
                // moved primary button to top so it can stack on top of the column in mobile more easily
                <StyledPrimaryWrapper id="FODInternalNavPrimaryButton">
                    <PrimaryNavItem
                        {...primaryNavButtonProps}
                        className="FODInternalNavbarListItem"
                        data-testid="internal-nav-primary-btn"
                    >
                        <NavLink
                            tabIndex={
                                screenSize?.isMobile || screenSize?.isTablet
                                    ? 1
                                    : newButtonOrder.length + 1
                            }
                            href={
                                primary_button_url_id
                                    ? selected_primary_button_url.link
                                    : primary_button_url
                            }
                            className={`${primary_button_class} FODGAInternalNavbarItem FODGAInternalNavbarItemLink FODV5GAInternalNavbarClickEvent`}
                            {...internalNavbarDataAttr}
                            data-clicklocation="Primary Internal Navbar Button"
                            data-clickurl={
                                primary_button_url_id
                                    ? selected_primary_button_url.link
                                    : primary_button_url
                            }
                            id={primary_button_id}
                            target={
                                primaryTarget !== undefined
                                    ? primaryTarget
                                        ? "_blank"
                                        : "_self"
                                    : open_primary_button_in_new_tab
                                        ? "_blank"
                                        : "_self"
                            }
                            flexDirection="row"
                        >
                            {hide_cta_icons
                                ? null
                                : fetchDetailIcon(
                                    primary_button_text,
                                    null,
                                    24
                                )}
                            {formatText(rowData, primary_button_text)}
                        </NavLink>
                    </PrimaryNavItem>
                </StyledPrimaryWrapper>
            ) : null}

            <NavWrapper className="FODNavWrapper">
                <ListWrapper
                    className="FODInternalNavbarListWrapper"
                    includePrimaryBtn={
                        include_primary_button && primaryLink !== ""
                    }
                >
                    {buttons
                        ? [
                            buttons[newButtonOrder[0]],
                            buttons[newButtonOrder[1]],
                            buttons[newButtonOrder[2]],
                            buttons[newButtonOrder[3]],
                            buttons[newButtonOrder[4]],
                        ]
                        : null}
                </ListWrapper>
            </NavWrapper>
            {visible && <Dropdown {...dropdownProps} />}
        </StyledInternalNavbar>
    );
}

export default InternalNavbar;
